module.exports = __webpack_public_path__ + "assets/img/43531013d68f7773c5e652532ecc2de1.png";